var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Title',{attrs:{"title-text":_vm.$t('resetPassword_title'),"text":("" + (_vm.$t('requestPassword_title_text'))),"data-qa":"por-request--title"}}),_c('RequestPasswordForm',{attrs:{"data-qa":"request-password-form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }